import { Component, Input, OnDestroy, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Actions, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { QueryRef } from 'apollo-angular';
import { SubSink } from 'subsink';

import { GetConfigValuesQuery, GetConfigValuesQueryVariables } from '../../../generated/graphql.generated';
import { EventSelectComponent } from '../../custom-inputs/event-select/event-select.component';
import { CalendarEvent } from '../../interfaces/calendarEvents';
import { JobInvoiceActions } from '../../job/job-invoice/job-invoice.actions';
import { createConfigSelector } from '../../state/branding.store';

import { MutateObjectComponent, MutateObjectElement } from '../mutate-object/mutate-object.component';

@Component({
  selector: 'app-mutate-invoice',
  templateUrl: './mutate-invoice.component.html',
  styleUrls: ['./mutate-invoice.component.scss']
})
export class MutateInvoiceComponent implements OnInit, OnDestroy {

  @ViewChild('mutate') mutateRef: MutateObjectComponent;

  // Template Refs
  @ViewChild('events') eventsRef: TemplateRef<any>;

  @ViewChild(EventSelectComponent) eventSelectRef: EventSelectComponent;

  @Input() mutateType: 'update' | 'create';

  // ADDITIONAL INPUTS
  @Input() jobId: string;

  configQueryRef: QueryRef<GetConfigValuesQuery, GetConfigValuesQueryVariables>;

  steps: MutateObjectElement[];

  disableMultipleEvents$ = this.store.select(createConfigSelector('INVOICE_DISABLEMULTIPLEEVENTS'));

  invoiceForm = new FormGroup({
    events: new FormControl([], [ Validators.required ]),
  });

  subs = new SubSink();

  constructor(
    private store: Store,
    private actions$: Actions,
  ) {}

  ngOnInit(): void {
    this.subs.sink = this.actions$.pipe(
      ofType(JobInvoiceActions.createInvoiceSuccess),
    ).subscribe(() => {
      this.mutateRef.closeDialog();
    });

    this.subs.sink = this.actions$.pipe(
      ofType(JobInvoiceActions.createInvoiceError),
    ).subscribe(() => {
      this.mutateRef.loading = false;
    });
  }

  ngOnDestroy(): void {
    this.subs.unsubscribe();
  }

  openDialog() {

    this.steps = [
      { name: 'Events', ref: this.eventsRef, control: 'events', type: 'array' },
    ];

    this.invoiceForm.reset({
      events: [],
    });

    this.mutateRef.mutateType = this.mutateType;
    this.mutateRef.steps = this.steps;
    this.mutateRef.openDialog();

    if (this.eventSelectRef) {
      this.eventSelectRef.searchEvents();
    }
  }

  mutateInvoice() {
    if (this.mutateType === 'update') {
      throw new Error('Update invoice not implemented');
    } else if (this.mutateType === 'create') {
      this.createInvoice();
    }
  }

  createInvoice() {
    const { value } = this.invoiceForm;
    const eventIds = value.events.map((e: CalendarEvent) => e.id);

    this.store.dispatch(JobInvoiceActions.createInvoiceButtonClicked({
      eventIds,
      jobId: this.jobId,
    }));
  }

}
